import { CollectionName, CollectionVisibility } from "../registry/collection-registry"
import type { CollectionCreateSchema } from "../types/typesense"

export const pesticidesSchema: CollectionCreateSchema = {
  name: CollectionName.Pesticides,
  fields: [
    {
      name: "label",
      type: "string",
      facet: false,
    },
  ],
  visibility: CollectionVisibility.Public,
}
